const axios = require("axios").create({
  baseURL: process.env.REACT_APP_IQSIM_BASE_URL,
});

export default axios;
